import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import AdNumber from "./components/adNumber/AdNumber";
import LabelsCA from "./components/labelsCA/LabelsCA";
import LessThanMarket from "./components/lessThanMarket/LessThanMarket";
import ShareNP from "./components/shareNP/ShareNP";
import stl from "./LeftColumn.module.css";
import useHelpers from "@hooks/useHelpers";
import CarMoneyInfoBox from "../CarMoneyInfoBox/CarMoneyInfoBox";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
var LeftColumn = function LeftColumn(_ref) {
  var _price$vat_price;
  var isTrackingView = _ref.isTrackingView,
    isCancelled = _ref.isCancelled;
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t;
  var _usePostDetails = usePostDetails(),
    postDetails = _usePostDetails.postDetails,
    helpers = _usePostDetails.helpers;
  var _ref2 = postDetails || {},
    details = _ref2.details,
    price = _ref2.price,
    analytics = _ref2.analytics,
    footer = _ref2.footer;
  var _useHelpers = useHelpers(),
    createUrlAbsolute = _useHelpers.createUrlAbsolute;
  if (!(postDetails !== null && postDetails !== void 0 && postDetails.details)) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container,
    id: "left-column-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-hide"
  }, /*#__PURE__*/React.createElement("h1", {
    className: stl.carName,
    id: "post-car-title"
  }, helpers.getPostTitle()), !isTrackingView && (details === null || details === void 0 ? void 0 : details.low_mileage_text) && /*#__PURE__*/React.createElement(LessThanMarket, {
    lowMileage: details === null || details === void 0 ? void 0 : details.low_mileage_text
  }), !isTrackingView && /*#__PURE__*/React.createElement(LabelsCA, {
    tags: details === null || details === void 0 ? void 0 : details.tags
  }), !isTrackingView && /*#__PURE__*/React.createElement(CarMoneyInfoBox, null), isTrackingView && /*#__PURE__*/React.createElement("div", {
    className: stl.trackingPrice,
    id: "tracking-price-section"
  }, /*#__PURE__*/React.createElement("div", {
    id: "tracking-total-price"
  }, /*#__PURE__*/React.createElement("strong", {
    id: "tracking-cash-label"
  }, t("cash_price", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", {
    id: "tracking-cash-value",
    style: {
      color: isCancelled && (footer === null || footer === void 0 ? void 0 : footer.remaining_price) > 0 ? "#00B64E" : ""
    }
  }, footer !== null && footer !== void 0 && footer.total_price ? footer === null || footer === void 0 ? void 0 : footer.total_price : price === null || price === void 0 ? void 0 : (_price$vat_price = price.vat_price) === null || _price$vat_price === void 0 ? void 0 : _price$vat_price.text, /*#__PURE__*/React.createElement("span", {
    id: "tracking-cash-currency"
  }, t("sar", {
    ns: "web_common"
  })))), isCancelled ? /*#__PURE__*/React.createElement("div", {
    id: "tracking-cancelled-section"
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.isCancelled,
    id: "tracking-cancelled-text"
  }, " ", t("request_canceled", {
    ns: "web_post_view"
  }))) : (footer === null || footer === void 0 ? void 0 : footer.remaining_price) <= 0 ? /*#__PURE__*/React.createElement("div", {
    id: "tracking-fullypaid-section"
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.fullypaid,
    id: "tracking-fullypaid-text"
  }, " ", t("fully_paid", {
    ns: "web_post_view"
  }))) : (footer === null || footer === void 0 ? void 0 : footer.remaining_price) && /*#__PURE__*/React.createElement("div", {
    id: "tracking-remaining-section"
  }, /*#__PURE__*/React.createElement("strong", {
    id: "tracking-remaining-label"
  }, t("remaining_amount", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", {
    id: "tracking-remaining-value"
  }, footer === null || footer === void 0 ? void 0 : footer.remaining_price, /*#__PURE__*/React.createElement("span", {
    id: "tracking-remaining-currency"
  }, t("sar", {
    ns: "web_common"
  }))))), !isTrackingView && /*#__PURE__*/React.createElement(ShareNP, {
    postDynamicLink: createUrlAbsolute("/cardetail/".concat(helpers.getPostId()))
  }), /*#__PURE__*/React.createElement(AdNumber, {
    adNumber: helpers.getPostId(),
    isTrackingView: isTrackingView
  }))));
};
export default LeftColumn;